import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../__legacy__/models/error.model';
import { IMainApiService } from '../../../../__legacy__/services/api.service';
import { IApiService } from '../../../../__legacy__/services/api.service.base';

interface IProjectOverviewResponse {
  waitingForAnnotationCount: number;
  draftsCount: number;
  toReviewCount: number;
  rejectedCount: number;
  acceptedCount: number;
  unclearCount: number;
  totalImageCount: number;
  publishMoreDatasets: boolean;
  unclearImageDate?: string;
  unclearImageId?: string;
}

export interface IProjectOverviewApiService {
  getProjectOverviewAsync: (projectId: string) => Promise<IProjectOverviewResponse | ACDLError>;
}

export namespace IProjectOverviewApiService {
  export const $: interfaces.ServiceIdentifier<IProjectOverviewApiService> = Symbol('PROJECT_OVERVIEW_API_SERVICE');
}

@injectable()
export class ProjectOverviewApiService implements IProjectOverviewApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  getProjectOverviewAsync = async (projectId: string): Promise<IProjectOverviewResponse | ACDLError> => {
    return await this.apiService.getAsync<IProjectOverviewResponse>('/Projects/Overview', { params: { projectId } });
  };
}
